// 배너 리스트
export const BANNER_LIST_URL = "api/main/banner/list";

// 로고 리스트
export const LOGO_LIST_URL = "api/main/logo/list";

// 1:1 문의 등록
export const INQUIRY_URL = "api/board/update";

// 게시판 리스트
export const BOARD_LIST_URL = "api/board/list";

// 게시판 상세
export const BOARD_DETAIL_URL = "api/board/detail";

// 약관 내용 조회
export const TERMS_DETAIL_URL = "api/terms";

// 첨부파일 데이터
export const ATTACHMENT_URL = "api/main/solution/list";